import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaFacebookF, FaInstagram, FaTwitter, FaPinterest, FaMapMarkerAlt, FaPhone, FaEnvelope, FaHeart } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: #35281e;
  color: white;
  padding: 60px 0 20px;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterLogo = styled.div`
  h2 {
    color: white;
    margin-bottom: 10px;
    font-family: 'Playfair Display', serif;
  }

  p {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const FooterSection = styled.div`
  h3 {
    color: white;
    font-size: 18px;
    margin-bottom: 20px;
    font-family: 'Playfair Display', serif;
  }
`;

const FooterLinks = styled(FooterSection)`
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #e09f3e;
    }
  }
`;

const FooterContact = styled(FooterSection)`
  p {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  i {
    margin-right: 10px;
    color: #e09f3e;
  }
`;

const FooterSocial = styled(FooterSection)`
  .social-icons {
    display: flex;
    gap: 15px;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e09f3e;
    color: #35281e;
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  p {
    margin-bottom: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
  }

  i {
    color: #b85c38;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterLogo>
            <h2>The Artisans Table</h2>
            <p>Artisanal cafe & bakery</p>
          </FooterLogo>
          
          <FooterLinks>
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </FooterLinks>
          
          <FooterContact>
            <h3>Contact Us</h3>
            <p><FaMapMarkerAlt /> 123 Artisan Street, Craftsville, CA 94321</p>
            <p><FaPhone /> (555) 123-4567</p>
            <p><FaEnvelope /> info@theartisanstable.com</p>
          </FooterContact>
          
          <FooterSocial>
            <h3>Follow Us</h3>
            <div className="social-icons">
              <SocialIcon href="#" target="_blank" aria-label="Facebook"><FaFacebookF /></SocialIcon>
              <SocialIcon href="#" target="_blank" aria-label="Instagram"><FaInstagram /></SocialIcon>
              <SocialIcon href="#" target="_blank" aria-label="Twitter"><FaTwitter /></SocialIcon>
              <SocialIcon href="#" target="_blank" aria-label="Pinterest"><FaPinterest /></SocialIcon>
            </div>
          </FooterSocial>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; {new Date().getFullYear()} The Artisans Table. All Rights Reserved.</p>
          <p>Designed with <FaHeart /> for food lovers</p>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
